<template>

  <div>

    <ConfirmAddOnDialog v-model="showConfirmPurchaseDialog" :add-ons="addOnsToConfirm" :total-due="totalDue" :on-close="onAddOnAdded"></ConfirmAddOnDialog>
    <ConfirmCancelAddOnDialog v-model="showConfirmCancelDialogFlag" :add-on="addOnToCancel" :on-close="onAddOnAdded"></ConfirmCancelAddOnDialog>

    <v-dialog v-model="show" max-width="600px">

      <v-card color="#f0f0f0">
        <v-card-title v-if="addOns.available && addOns.available.length > 0">
          <h2>Available Add Ons</h2>
          <v-spacer></v-spacer>
          <v-btn flat icon color="itoviGrayMid" @click="show=false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pt-0">

          <!-- Available addons -->
          <v-card class="mx-auto mt-2" v-if="addOns.available.length > 0">
            <v-card-text v-if="is_mobile_app_webview">
              Access your iTOVi Dashboard on the web to manage Add-ons & Premium Content.
            </v-card-text>
            <v-card-text class="text-xs-left" v-else>
              <!-- Warranty -->
              <template v-if="addOns.available[0].name === 'Extended Warranty'">
                <v-layout row align-center class="mb-2">
                  <v-flex xs8 class="plan-title">Extended Warranty</v-flex>
                  <v-flex xs4 class="txt-bold text-xs-center">Price: ${{ formatPrice(addOns.available[0].price) }}</v-flex>
                </v-layout>

                <v-layout row class="mb-4">
                  <v-flex xs8>{{ addOns.available[0].description }}</v-flex>
                  <v-flex xs4 class="text-xs-center">
                    <v-btn round outline color="primary" class="txt-bold mt-0" v-if="addOns.available[0].inCart === 'monthly'">
                      IN THE CART
                    </v-btn>
                    <v-btn round color="primary" class="txt-bold mt-0" v-else @click="addToCart(addOns.available[0])">
                      ADD TO CART
                    </v-btn>
                  </v-flex>
                </v-layout>

                <v-divider class="mb-3"></v-divider>
              </template>

              <!-- Premium Content -->
              <template v-if="addOns.available[0].name !== 'Extended Warranty' || addOns.available.length > 1">
                <h2 class="text-xs-center mb-3">Subscription Services</h2>

                <p class="text-xs-center">We offer monthly and annual options for all your subscriptions</p>

                <v-layout row class="mb-5">
                  <v-flex xs2></v-flex>
                  <v-flex xs4 class="text-xs-center" :class="monthlyTab ? 'txt-bold' : ''"
                          style="cursor: pointer;" :style="monthlyTab ? 'border-bottom: 3px solid #027689' : ''"
                          @click="billedMonthly()">BILLED MONTHLY</v-flex>

                  <v-flex xs4 class="text-xs-center offset-xs1" :class="!monthlyTab ? 'txt-bold' : ''"
                          style="cursor: pointer" :style="!monthlyTab ? 'border-bottom: 3px solid #027689' : ''"
                          @click="billedAnnually()">BILLED ANNUALLY</v-flex>
                  <v-flex xs2></v-flex>
                </v-layout>

                <!-- Monthly Tab -->
                <template v-if="monthlyTab">
                  <template v-for="(item, index) in addOns.available">
                    <template v-if="item.name !== 'Extended Warranty'">
                      <v-layout :key="index" row align-center class="mb-2">
                        <v-flex xs8 class="plan-title">{{ item.name }}</v-flex>
                        <v-flex xs4 class="txt-bold text-xs-center">${{ formatPrice(item.monthly) }}/month</v-flex>
                      </v-layout>

                      <v-layout :key="index * 1000 + buttonIndex + 1000" row class="mb-5">
                        <v-flex xs8>{{ item.description }}</v-flex>

                        <v-flex xs4 class="text-xs-center">
                          <v-btn round outline color="primary" class="txt-bold mt-0" v-if="item.inCart === 'monthly'">
                            IN THE CART
                          </v-btn>
                          <v-btn round outline color="#999999" class="txt-bold mt-0" style="background-color: #dddddd !important;" v-else-if="item.inCart === 'annually'">
                            IN THE CART
                          </v-btn>
                          <v-btn round color="primary" class="txt-bold mt-0" v-else @click="addToCart(item)">
                            ADD TO CART
                          </v-btn>

                          <p class="mb-0" style="font-size: 10px; color: #999999;" v-if="item.inCart === 'annually'">annual subscription in the cart</p>
                        </v-flex>
                      </v-layout>
                    </template>
                  </template>
                </template>

                <!-- Annual Tab -->
                <template v-if="!monthlyTab">
                  <template v-for="(item, index) in addOns.available">
                    <template v-if="item.name !== 'Extended Warranty'">
                      <v-layout :key="index * 10000 + buttonIndex + 10000" row align-center class="mb-2">
                        <v-flex xs8 class="plan-title">{{ item.name }}</v-flex>
                        <v-flex xs4 class="txt-bold text-xs-center">${{ formatPrice(item.yearly) }}/year</v-flex>
                      </v-layout>

                      <v-layout :key="index * 100000 + buttonIndex + 100000" row class="mb-5">
                        <v-flex xs8>{{ item.description }}</v-flex>

                        <v-flex xs4 class="text-xs-center">
                          <v-btn round outline color="primary" class="txt-bold mt-0" v-if="item.inCart === 'annually'">
                            IN THE CART
                          </v-btn>
                          <v-btn round outline color="#999999" class="txt-bold mt-0" style="background-color: #dddddd !important;" v-else-if="item.inCart === 'monthly'">
                            IN THE CART
                          </v-btn>
                          <v-btn round color="primary" class="txt-bold mt-0" v-else @click="addToCart(item, true)">
                            ADD TO CART
                          </v-btn>

                          <p class="mb-0" style="font-size: 10px; color: #999999;" v-if="item.inCart === 'monthly'">monthly subscription in the cart</p>
                        </v-flex>
                      </v-layout>
                    </template>
                  </template>
                </template>

                <v-divider class="mb-4"></v-divider>
              </template>

              <!-- Cart -->
              <h2 class="text-xs-center mb-4">Shopping Cart</h2>

              <template v-for="(item, index) in addOns.available">
                <v-layout :key="index * 1000000 + buttonIndex + 1000000" row align-center class="mb-3" v-if="item.inCart !== undefined && item.inCart !== ''">
                  <v-flex xs8 class="plan-title">{{ item.name }}</v-flex>

                  <v-flex xs3 class="txt-bold" v-if="item.name === 'Extended Warranty'">${{ formatPrice(item.price) }}</v-flex>
                  <v-flex xs3 class="txt-bold" v-else-if="item.inCart === 'monthly'">${{ formatPrice(item.monthly) }}/month</v-flex>
                  <v-flex xs3 class="txt-bold" v-else-if="item.inCart === 'annually'">${{ formatPrice(item.yearly) }}/year</v-flex>

                  <img src="../../../assets/trash.svg" style="width: 3%; cursor: pointer;" @click="removeFromCart(item)">
                </v-layout>
              </template>

              <v-layout row justify-center wrap class="mt-4">
                <v-flex xs4></v-flex>
                <v-flex xs4>
                  <v-btn round block color="primary" v-if="totalDue > 0" @click="showConfirmAddOnDialog()">PURCHASE</v-btn>
                  <v-btn round block color="#999999" style="background-color: #dddddd !important;" v-else>PURCHASE</v-btn>
                </v-flex>
                <v-flex xs4></v-flex>
              </v-layout>
            </v-card-text>
          </v-card>

          <!-- Applied AddOns -->
          <v-card-title v-if="addOns.applied && addOns.applied.length > 0">
            <h2>Applied Add Ons</h2>
            <v-spacer></v-spacer>
            <v-btn flat icon color="itoviGrayMid" v-if="addOns.available.length === 0" @click="show=false"><v-icon>close</v-icon></v-btn>
          </v-card-title>
          <template v-for="(item, index) in addOns.applied">

            <v-card :key="index + addOns.available.length" class="mx-auto mt-2" >

              <v-card-text class="text-xs-left">

                <div class="mb-1 plan-title">{{ item.name }}</div>

                <v-divider class="mt-2 mb-2"></v-divider>

                <div class="mb-2">{{ item.description }}</div>

                <v-layout align-center row wrap>
                  <span v-if="item.yearly > 0 || item.monthly > 0" class="txt-bold">Price:&nbsp;</span>
                  <span v-if="item.is_yearly && item.yearly > 0" class="txt-bold pr-3">${{ item.yearly }} / year</span>
                  <span v-if="!item.is_yearly && item.monthly > 0" class="txt-bold pr-3">${{ item.monthly }} / mo</span>
                </v-layout>


                <v-layout v-if="item.status === 'active' && item.yearly !== 0 && item.monthly !== 0" justify-center wrap class="mt-2">
                  <v-btn round color="primary" @click="showConfirmCancelDialog(item)">Cancel Subscription</v-btn>
                </v-layout>
                <div class="text-xs-center pt-3" v-if="item.status === 'pending_cancel'" >This add-on has been canceled. You will continue to have access to {{ item.name }} premium content until your next billing cycle. This add-on will not renew and you will not be charged.</div>



                <!--      what's included section          -->
                <div v-if="!!item.included && item.included.length > 0" class="mt-2">
                  <!--                  <h4>What's included:</h4>-->
                  <ul>
                    <template v-for="(updradeDetailsIncludedItem, index2) in item.included">
                      <li :key="index2">{{ updradeDetailsIncludedItem }}</li>
                    </template>
                  </ul>
                </div>

              </v-card-text>



            </v-card>

          </template>


        </v-card-text>

      </v-card>
    </v-dialog>
  </div>

</template>

<style lang="scss" scoped>
  .plan-title {
    font-size: 15pt;
    color: #027689;
  }
</style>

<script>
  import ConfirmAddOnDialog from "./ConfirmAddOnDialog"
  import ConfirmCancelAddOnDialog from "./ConfirmCancelAddOnDialog"

  export default {
    components: {
      ConfirmAddOnDialog,
      ConfirmCancelAddOnDialog
    },
    data: ()=> ({
      addOnsToConfirm: null,
      addOnToCancel: null,
      addOnYearlyOption: false,
      showConfirmPurchaseDialog: false,
      showConfirmCancelDialogFlag: false,
      is_mobile_app_webview: false,
      showLoadingDialog: false,
      monthlyTab: true,
      buttonIndex: 0,
      totalDue: 0,
    }),
    props: {
      value: {
        type: Boolean,
        default: false
      },
      addOns: {
        type: Object,
        default: () => ({
          applied: [
            {
              id: 0,
              name: '',
              price: 0,
              monthly: 0,
              yearly: 0,
              status: '',//active, pending_cancel
              is_yearly: false,
              description: ''
            }
          ],
          available: [
            {
              id: 0,
              name: '',
              price: 0,
              monthly: 0,
              yearly: 0,
              is_yearly: false,
              description: ''
            }
          ],
        })
      },
    },
    created(){
      this.is_mobile_app_webview = this.$route.query.hasOwnProperty('apptoken');
    },
    methods: {
      onAddOnAdded(success) {
        if (success) {
          this.show = false
        }
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2);
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      async showConfirmAddOnDialog() {
        // console.log(addOn);
        // console.log(this.is_mobile_app_webview);
        let addOns = [];
        for (let i = 0; i < this.addOns.available.length; i++) {
          let addOn = this.addOns.available[i];
          if (addOn.hasOwnProperty("inCart") && addOn.inCart !== undefined && addOn.inCart !== "") {
            addOns.push(addOn);
          }
        }
        this.addOnsToConfirm = addOns;
        this.showConfirmPurchaseDialog = true
      },
      async showConfirmCancelDialog(addOn) {
        // console.log(addOn);
        // console.log(this.is_mobile_app_webview);
        this.addOnToCancel = addOn;
        this.showConfirmCancelDialogFlag = true
      },
      addToCart(item, annually = false) {
        item.inCart = annually ? "annually" : "monthly";
        this.buttonIndex++;
        this.totalDue += (annually ? parseFloat(item.yearly) : parseFloat(item.price));
      },
      billedMonthly() {
        this.monthlyTab = true;
      },
      billedAnnually() {
        this.monthlyTab = false;
      },
      removeFromCart(item) {
        this.totalDue -= (item.inCart === "annually" ? parseFloat(item.yearly) : parseFloat(item.price));
        item.inCart = "";
        this.buttonIndex--;
      }
    },
    computed: {
      show: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      }
    }
  }
</script>
